/** Taiji (fx 'taiji'): a turning yin-yang under the palm, the target or the spot picked. */
import { registerFx } from './registry';

registerFx('taiji', (host) => ({
  skill: ({ src, tgt, s, sx, sy, tx, ty, spot }) => {
    const [x, y] = spot || tgt ? [tx, ty] : [sx, sy];
    if (s.kind !== 'heal') host.swingArc(src, 'palm', '235,240,250');
    host.fx.push({ type: 'yinyang', x, y, t: 0, life: 0.7, r: tgt ? 16 : s.aoe ? 34 : 24 });
    if (s.kind === 'heal') {
      host.fx.push({ type: 'sigil', x, y, t: 0, life: 1, r: 26, col: '235,240,250' });
      host.sfx.heal();
    } else {
      if (s.aoe) host.fx.push({ type: 'ring', x, y, t: 0, life: 0.5, r: 48, col: '235,240,250' });
      host.sfx.swing();
    }
  },
}));
